import React from 'react'
import { useEffect, useState } from 'react';
import { Footer } from '../../../common/footer/footer';


import { useTranslation } from "react-i18next";
import Sidebar from "../sidebar/sidebar.js";


export const CustomerAskTheExpertJsx = (props) => {
  const { t } = useTranslation();
  const {
    onDeleteButtonClick,
    onEditButtonClick,
    expertData
    // meta
  } = props;
  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])

 
  const [meta] = useState({});
  
 


  // {t("PRINT.TITLE")}
  return (
    <>
      <section className="entiredashboard admindashboard">

        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-3">


              <div className="dashboardleftpanel martop40">

                <div className="dashboardlink martop40">
                  <Sidebar />
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-sm-9">

              <div className="dashboardrightpanel martop40">
                <h2>All plans</h2>



                <div className="expertsection martop30 mb-5">
                  {
                    expertData.length > 0 ?

                      <div className="searchdetails">
                        <table className="searchdetailsdb">
                          <tr>
                            <th>Sl No</th>
                            <th>Plan name</th>
                            <th>Plan type</th>
                            <th>Plan duration</th>
                            <th>Plan for</th>
                            <th>Category</th>
                            <th>Ads Limit</th>
                            <th>Offer Limit</th>
                            <th>Product Limit</th>
                            <th>Experts Limit</th>
                            <th>Price</th>
                            <th>Action</th>
                          </tr>

                          {expertData?.map((data, index) => (
                            <>
                              <tr>
                                <td>{index + 1}</td>
                                <td>{data?.subscriptionPlan?.planName}</td>
                                <td>{data?.planType}</td>
                                <td>{data?.duration} days</td>
                                <td>{data?.subscriptionPlan?.planFor}</td>
                                <td>{data?.subscriptionPlan?.institutionCategory?.name}</td>
                                <td>{data?.adsLimit}</td>
                                <td>{data?.offersLimit}</td>
                                <td>{data?.productsLimit}</td>
                                <td>{data?.expertsLimit}</td>
                                <td>{data?.price} $</td>
                                <td>
                                  <button className="btn btn-success" onClick={() => onEditButtonClick(data?.subscriptionPlanTypeId)}>Edit</button>
                                  <button className="btn btn-danger" onClick={() => onDeleteButtonClick(data?.subscriptionPlanTypeId)} >delete</button></td>
                              </tr>
                            </>
                          ))}

                        </table>



                      </div>
                      :
                      <div className="opacity1">{meta?.totalPages ? t("SEARCHEXPERT.SEARCHRESULTNOTFOUND") : 'Search for expert'}</div>
                  }


                  {/* {expertData?.length > 0 && <Pagination
            limit={10}
            totalCount={expertData?.meta?.totalCount}
            onPaginationButtonClick={onPaginationButtonClick}
          />} */}
                </div>
              </div>
            </div>
          </div>

        </div>



      </section><Footer />
    </>

  );
};

export default CustomerAskTheExpertJsx;